<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 12 12">
  <defs>
    <style>
      .cls-1 {
        fill: #667080;
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path class="cls-1" d="M6,1.6c-1,0-1.9.3-2.7.8-.8.5-1.4,1.3-1.8,2.2-.4.9-.5,1.9-.3,2.8.2.9.7,1.8,1.3,2.5.7.7,1.6,1.1,2.5,1.3.9.2,1.9,0,2.8-.3.9-.4,1.7-1,2.2-1.8.5-.8.8-1.7.8-2.7,0-1.3-.5-2.5-1.4-3.4-.9-.9-2.2-1.4-3.4-1.4ZM6,10.6c-.8,0-1.6-.2-2.3-.7-.7-.5-1.2-1.1-1.5-1.9-.3-.8-.4-1.6-.2-2.4.2-.8.6-1.5,1.1-2.1.6-.6,1.3-1,2.1-1.1.8-.2,1.6,0,2.4.2.8.3,1.4.8,1.9,1.5.5.7.7,1.5.7,2.3,0,1.1-.4,2.1-1.2,2.9-.8.8-1.8,1.2-2.9,1.2ZM6.8,8.8c0,0,0,.2-.1.3,0,0-.2.1-.3.1-.2,0-.4,0-.5-.2-.1-.1-.2-.3-.2-.5v-1.9c0,0-.2,0-.3-.1,0,0-.1-.2-.1-.3s0-.2.1-.3c0,0,.2-.1.3-.1.2,0,.4,0,.5.2.1.1.2.3.2.5v1.9c0,0,.2,0,.3.1,0,0,.1.2.1.3ZM5.2,4.4c0-.1,0-.2,0-.3s.1-.2.3-.2c.1,0,.2,0,.3,0,.1,0,.2,0,.3.2,0,0,.1.2.2.3,0,.1,0,.2,0,.3,0,.1-.1.2-.2.3s-.2,0-.3,0-.3,0-.4-.2c-.1-.1-.2-.2-.2-.4Z"/>
</svg>